export default __webpack_public_path__ + "img/like.8581e0de.svg";